import NavbarEcom from "../components/NavbarEcom";
import Categories from "../components/Categories";
import Products from "../components/Products";

const EcomHome = () => {
  return (
    <div>
      <NavbarEcom />
      <Categories />
      <Products />
    </div>
  );
};

export default EcomHome;
